import { hideLoginError, showLoginError } from './getLoginView.js';

export function validateLoginForm(loginForm) {
  if (!loginForm.user) {
    return validateLoginError('login.usuario_error');
  }

  if (!loginForm.password) {
    return validateLoginError('login.password_error');
  }

  // select groupsArray
  if (loginForm?.groupsArray?.length > 1 && !loginForm.group) {
    return validateLoginError('login.group_error');
  }

  return validateLoginOk();
}

function validateLoginOk() {
  hideLoginError();
  return true;
}

function validateLoginError(error) {
  showLoginError(error);
  return false;
}
